'use client';
import React from 'react';
import { FormBlockProps } from '@/app/_blocks/FormBlockGraphQL/types';
import { Gutter } from '../Gutter';
import { Form } from '@/payload/payload-types';
import { FormFieldBlock } from '@payloadcms/plugin-form-builder/types';
import { FormItem } from './FormItem';
import ToggleSwitch from '../ToggleSwitch';

import classes from './index.module.scss';
import { useTranslations } from 'next-intl';

export const FormBlock: React.FC<{
  formBlock: FormBlockProps;
}> = ({ formBlock }) => {
  const {
    introContent,
    form: formFromProps,
    useSecondaryForm,
    secondaryForm,
    submitButtonColor,
  } = formBlock;

  const t = useTranslations();

  const [useB2bForm, setUseB2bForm] = React.useState(false);
  const {
    id: formID,
    submitButtonLabel,
    confirmationType,
    redirect,
    confirmationMessage,
    fields: formFields,
  }: Form = React.useMemo(
    () => (useB2bForm && useSecondaryForm && secondaryForm ? secondaryForm as Form : formFromProps) as Form,
    [
      useB2bForm,
      useSecondaryForm,
      secondaryForm,
      formFromProps,
    ]);

  return (
    <Gutter>
      {useSecondaryForm &&
        <ToggleSwitch
          className={classes.switchWrapper}
          checked={useB2bForm}
          onChange={setUseB2bForm}
          unCheckedLabel={t('forms.labelB2c')}
          checkedLabel={t('forms.labelB2b')}
        />
      }
      <div className={classes.formWrapper}>
        <FormItem
          key={formID?.toString() || ''}
          formID={formID?.toString() || ''}
          formFromProps={formFromProps as Form}
          formFields={formFields as FormFieldBlock[]}
          confirmationType={confirmationType}
          confirmationMessage={confirmationMessage}
          introContent={introContent}
          submitButtonLabel={submitButtonLabel}
          submitButtonColor={submitButtonColor}
          redirect={redirect}
        />
      </div>
    </Gutter>
  );
};
